module.exports = __webpack_public_path__ + "static/media/homeGif6.de45b9f8.gif";